import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: 'INSTANCE_ID_KEY',
    stateKey: 'instance_id',
  },
  {
    gridXs: 12,
    label: 'INSTANCE_NAME_KEY',
    stateKey: 'instance_name',
  },
  {
    gridXs: 12,
    label: 'PUBLIC_IP_KEY',
    stateKey: 'public_ip',
    placeholder: '000.000.0.00',
  },
];

export default fields;
